import { FlightFilterCategories } from '@pages/FlightSearchResult/components/FlightFilters/type';
import { removeSpecificPerLegSearchFilterParam } from '@pages/FlightSearchResult/flightPerLegSearchFilter';

import { FlightSearchResultSearchParams } from '@wegoTypes/flights/flightSearchParams';
import { FlightSortType } from '@wegoTypes/flights/flightSortType';
import { SortOrder } from '@wegoTypes/sortOrder';

export const removeSearchParams = (
  searchParams: URLSearchParams,
  filter: FlightFilterCategories,
  activeLeg: number,
) => {
  let filterParamsToBeDeleted: FlightSearchResultSearchParams[] = [];

  switch (filter) {
    case FlightFilterCategories.Stops:
      filterParamsToBeDeleted = [FlightSearchResultSearchParams.Stops];
      break;

    case FlightFilterCategories.PaymentMethod:
      filterParamsToBeDeleted = [FlightSearchResultSearchParams.SelectedPaymentMethod];
      break;

    case FlightFilterCategories.BookingOptions:
      filterParamsToBeDeleted = [FlightSearchResultSearchParams.Providers];
      break;

    case FlightFilterCategories.Experience:
      filterParamsToBeDeleted = [FlightSearchResultSearchParams.Experience];
      break;

    case FlightFilterCategories.BookingSites:
      filterParamsToBeDeleted = [FlightSearchResultSearchParams.ProviderCodes];
      break;

    case FlightFilterCategories.OriginAndDestination:
      filterParamsToBeDeleted = [
        FlightSearchResultSearchParams.Origin,
        FlightSearchResultSearchParams.Destination,
      ];
      break;

    case FlightFilterCategories.Transit:
      filterParamsToBeDeleted = [
        FlightSearchResultSearchParams.StopoverOptions,
        FlightSearchResultSearchParams.Stopovers,
      ];
      break;

    case FlightFilterCategories.Duration:
      filterParamsToBeDeleted = [
        FlightSearchResultSearchParams.DepartDuration,
        FlightSearchResultSearchParams.ReturnDuration,
        FlightSearchResultSearchParams.StopoverDuration,
      ];
      break;

    case FlightFilterCategories.Times:
      filterParamsToBeDeleted = [
        FlightSearchResultSearchParams.DepartLegArrivalTimeBlocks,
        FlightSearchResultSearchParams.DepartLegDepartureTimeBlocks,
        FlightSearchResultSearchParams.ReturnLegArrivalTimeBlocks,
        FlightSearchResultSearchParams.ReturnLegDepartureTimeBlocks,
      ];
      break;

    case FlightFilterCategories.Price:
      filterParamsToBeDeleted = [FlightSearchResultSearchParams.Price];
      break;

    case FlightFilterCategories.Airlines:
      filterParamsToBeDeleted = [
        FlightSearchResultSearchParams.Airlines,
        FlightSearchResultSearchParams.TripOptions,
      ];
      break;

    case FlightFilterCategories.Alliances:
      filterParamsToBeDeleted = [FlightSearchResultSearchParams.Alliances];
      break;
  }

  removeSpecificPerLegSearchFilterParam(searchParams, activeLeg === 0, filterParamsToBeDeleted);

  return searchParams;
};

export const getFlightSortOptions = (activeLeg: number) => [
  {
    titleKey: 'recommended_sort_type_title',
    subtitleKey: 'recommended_sort_type_description',
    sortOrder: 'desc' as SortOrder,
    sortType: 'score' as FlightSortType,
    buttonLabelKey: 'recommended',
  },
  {
    titleKey: 'cheapest_sort_type_menu_title',
    subtitleKey: 'cheapest_sort_type_menu_description',
    sortOrder: 'asc' as SortOrder,
    sortType: 'price' as FlightSortType,
    buttonLabelKey: 'cheapest',
  },
  {
    titleKey: 'fastest_sort_type_menu_title',
    subtitleKey: 'fastest_sort_type_menu_description',
    sortOrder: 'asc' as SortOrder,
    sortType: 'duration' as FlightSortType,
    buttonLabelKey: 'fastest',
  },
  {
    titleKey: 'earliest_sort_type_menu_title',
    subtitleKey: 'earliest_sort_type_menu_description',
    sortOrder: 'asc' as SortOrder,
    sortType: `leg${activeLeg + 1}_departure_time` as FlightSortType,
    buttonLabelKey: 'lbl_earliest',
  },
  {
    titleKey: 'latest_sort_type_menu_title',
    subtitleKey: 'latest_sort_type_menu_description',
    sortOrder: 'desc' as SortOrder,
    sortType: `leg${activeLeg + 1}_departure_time` as FlightSortType,
    buttonLabelKey: 'lbl_latest',
  },
];

export const getFilterResetGenzoObjects = (filter: FlightFilterCategories) => {
  switch (filter) {
    case FlightFilterCategories.Stops:
      return { stops: [] };

    case FlightFilterCategories.Experience:
      return { itinerary: [] };

    case FlightFilterCategories.Price:
      return { price_min_max_usd: [], price_selected_usd: [] };

    case FlightFilterCategories.Airlines:
      return { airlines: [], alliances: [] };

    case FlightFilterCategories.BookingOptions:
      return { booking_options: [] };

    case FlightFilterCategories.BookingSites:
      return { booking_sites: [] };

    case FlightFilterCategories.PaymentMethod:
      return { selected_payment_methods: [] };

    case FlightFilterCategories.OriginAndDestination:
      return { from_to_airports: [] };

    case FlightFilterCategories.Transit:
      return { no_change_airports_stopover: [], transit_airports: [] };

    case FlightFilterCategories.Times:
      return { arrivaltime_box_selected: undefined, departuretime_box_selected: undefined };

    case FlightFilterCategories.Duration:
      return {
        totalduration_min_max: undefined,
        totalduration_selected: undefined,
        transitduration_min_max: undefined,
        transitduration_selected: undefined,
      };
  }
  return {};
};
